import React from 'react';
import { TableCell, TableRow } from '@mui/material';

interface ListingRowProps {
  listing: any;
}

const ListingRow: React.FC<ListingRowProps> = ({ listing }) => {
  const minPrice = Math.min(...listing.variants.map((v: any) => v.price));
  const maxPrice = Math.max(...listing.variants.map((v: any) => v.price));
  const totalInventory = listing.variants.reduce(
    (acc: number, variant: any) => acc + variant.inventoryQuantity,
    0
  );

  return (
    <TableRow>
      <TableCell>
        {listing.images[0] && (
          <img
            src={listing.images[0].src}
            alt={listing.images[0].altText || 'Product image'}
            style={{ width: 50, height: 50, objectFit: 'cover' }}
          />
        )}
      </TableCell>
      <TableCell>{listing.title}</TableCell>
      <TableCell>{listing.vendor}</TableCell>
      <TableCell>{listing.product_type}</TableCell>
      <TableCell>
        {minPrice} - {maxPrice}
      </TableCell>
      <TableCell>{totalInventory}</TableCell>
      <TableCell>{listing.variants.map((variant: any) => variant.sku).join(', ')}</TableCell>
      <TableCell>{listing.status}</TableCell>
    </TableRow>
  );
};

export default ListingRow;
